<template>
  <div class="list">
    <div class="top">
      <showPage :listName="listName" />
    </div>
    <div style="float:left">
      <SelectModule
        :category="categoryList"
        :tags="tagList"
        @query="getParams"
        :minPriceOut="searchParams.minPrice"
        :maxPriceOut="searchParams.maxPrice"
        @getListName="getListName"
        ref="selectModule"
      />
      <listTitle
        :minPrice="searchParams.minPrice"
        :maxPrice="searchParams.maxPrice"
        @changePrice="changePrice"
        :total="total"
        @changetitleselect="changeOrderBy"
      />
      <div class="goodsList">
        <div>
          <div v-for="(item, index) in showList" :key="index" class="infoWrap">
            <goodsInfo :info="item" :showHighPrice="true" />
          </div>
          <div class="pagination">
            <pagination
              :total="total"
              @current-change="currentChange"
              :pageSize="searchParams.pageSize"
            />
          </div>
        </div>
        <div v-if="loading && !showList.length">
          <div class="noData" v-if="tagList.length">
            <img src="@/assets/imgs/index/noCity.png" alt="" />
          </div>
          <div class="noData" v-if="!tagList.length">
            <img src="@/assets/imgs/citynodata.png" alt="" />
          </div>
          <div class="font" v-if="tagList.length">
            {{TLang('抱歉没有找到相关的演出哦','my')}}
          </div>
          <div class="font" v-if="!tagList.length" style="line-height:17px">
            {{TLang('当前城市暂无演出信息','my')}}
          </div>
          <div class="font" v-if="!tagList.length" style="line-height:17px">
            {{TLang('如有疑问请联系','my')}}<span style="color:#333333;font-weight:bold"
              >{{tel}}</span
            >
          </div>
          <div class="allbtn" @click="toAll" v-if="tagList.length">
            {{TLang('查看所有演出','my')}}
          </div>
          <div
            class="allbtn changeCity"
            v-else
            @click.stop="$bus.$emit('changeCity')"
          >
            {{TLang('切换城市','list')}}
          </div>
        </div>
      </div>
    </div>
    <div class="hot">
      <hot :info="hotShowList" />
    </div>
  </div>
</template>

<script>
import showPage from "@/components/showList/showPage.vue";
import SelectModule from "@/components/showList/selectModule.vue";
import listTitle from "@/components/showList/listTitle.vue";
import goodsInfo from "@/components/showList/goodsInfo.vue";
import pagination from "@/components/showList/pagination.vue";
import hot from "@/components/showList/hot.vue";
import { unionFlag } from "@/utils";
import { setTitleInfo } from "@/utils/title";

export default {
  name: "list",
  data() {
    return {
      categoryList: [],
      categoryId: this.$route.query.categoryId,
      searchParams: {
        minPrice: "",
        maxPrice: "",
        categoryId: this.$route.query.categoryId,
        sortType: 0, // 默认综合排序
        pageSize: 24,
        pageIndex: 1 // 默认第一页
      },
      total: 0,
      showList: [], //演出列表集合
      hotShowList: [], // 热映
      tagList: [], // 查询条件集合
      loading: false,
      listName: "",
      minusNum: 0,
      tel: unionFlag() ? '400-618-2999' : '400-003-1010',
    };
  },
  components: {
    SelectModule,
    listTitle,
    goodsInfo,
    pagination,
    hot,
    showPage
  },
  created() {
    this.getWithChildren();
    this.getData();
    this.getHotData();
  },
  methods: {
    getListName(name) {
      this.listName = name;
    },
    toAll() {
      this.tagList = [];
      this.getParams(this.tagList);
    },
    changeOrderBy(orderBy) {
      this.searchParams.sortType = orderBy;
      this.getData();
    },
    currentChange(page) {
      this.searchParams.pageIndex = page;
      this.getData();
    },
    resetParams() {
      this.searchParams.categoryId = this.$route.query.categoryId;
      this.searchParams.sortType = 0;
      this.searchParams.minPrice = "";
      this.searchParams.maxPrice = "";
      this.searchParams.startTime = "";
      this.searchParams.endTime = "";
    },
    getParams(tagList) {
      // this.resetParams();
      let params = {
        categoryId: "",
        minPrice: "",
        maxPrice: "",
        startTime: "",
        endTime: ""
      };
      this.tagList = tagList;
      this.searchParams = Object.assign(
        this.searchParams,
        params, //  清空当前条件。并且不影响其他查询条件
        ...this.tagList
      );
      this.searchParams.pageIndex = 1;
      delete this.searchParams.value;
      delete this.searchParams.type;
      if (this.searchParams.id) {
        this.searchParams.categoryId = this.searchParams.id;
      }
      delete this.searchParams.id;
      this.getData();
      
      try {
        setTitleInfo({name: tagList && tagList[0] && tagList[0].value.split('-')[1] })
      } catch (error) {
        console.error(error)
      }
    },
    getHotData() {
      this.apis.home.getShowList({ type: 2, pageSize: 5 }).then(res => {
        this.hotShowList = this.deleteUnUsable(res.body.searches, 0);
      });
    },
    getData() {
      this.showList = [];
      this.total = 0;
      this.loading = false;
      let params = JSON.parse(JSON.stringify(this.searchParams));
      if (params.minPrice) {
        params.minPrice = Number(params.minPrice) * 100;
      } else {
        delete params.minPrice;
      }

      if (params.maxPrice) {
        params.maxPrice = Number(params.maxPrice) * 100;
      } else {
        delete params.maxPrice;
      }
      this.apis.home.getShowList({ type: 0, ...params }).then(res => {
        if (res.body.searches && res.body.searches.length > 0){
          res.body.searches = this.deleteUnUsable(res.body.searches, 0);
        }
        this.showList = res.body.searches || [];
       
        this.total = res.body.totalCount ? res.body.totalCount - this.minusNum : 0;
        this.loading = true;
      });
    },
    // 删除过期场次
    deleteUnUsable(searches, n){
      this.minusNum = n;
      searches.map((list, index) =>{
        if(!list.usable){
        // if (new Date(list.endTime) < new Date()){
          n = n + 1;
          searches.splice(index, 1);
          this.deleteUnUsable(searches, n);
          return;
        }
      })
      return searches;
    },
    getWithChildren() {
      let list = []
      this.apis.home
        .getWithChildren({
          channel: 6
        })
        .then(res => {
          res.body.forEach(value => {
            if (value.children && value.children.length) {
              this.categoryList.push(value);
            }
          });
          
          setTitleInfo({name: this.getName(res.body)})
        });
        
    },
    getName(list) {
      let name = '全部'
      list.some((item) => {
        if (item.id == this.categoryId) {
          name = item.name
          return true
        }
        if (item.children) {
          return  item.children.find(sub => {
            if (sub.id == this.categoryId) {
              name = sub.name
              return true
            }
          })
        }
      })
      return name
    },
    changePrice(obj) {
      this.$refs.selectModule.deletePeiceTag();
      this.searchParams = Object.assign(this.searchParams, obj);
      this.getData();
    }
  }
};
</script>

<style lang="less" scoped>
.infoWrap:nth-child(1) {
  margin-top: -8px;
}
.list {
  width: 1200px;
  margin: 0 auto;
  .clearfix;
}
.allbtn {
  background: linear-gradient(
    202deg,
    rgba(92, 180, 236, 1) 0%,
    rgba(61, 150, 226, 1) 100%
  );
  width: 100px;
  height: 34px;
  color: white;
  font-size: 12px;
  text-align: center;
  line-height: 34px;
  border-radius: 2px;
  margin: 26px auto;
  margin-bottom: 121px;
  cursor: pointer;
}
.noData {
  width: 216px;
  margin: 93px auto;
  margin-bottom: 0;
  img {
    width: 100%;
    height: 100%;
  }
}
.font {
  text-align: center;
  color: #999999;
  font-size: 12px;
  line-height: 31px;
}
.goodsList {
  width: 914px;
  overflow: hidden;
  border-left: 1px solid #e0e6ed;
  border-bottom: 1px solid #e0e6ed;
  border-right: 1px solid #e0e6ed;
  padding-left: 24px;
  padding-bottom: 24px;
}
// .pagination {
//   height: 80px;
//   margin-top: 24px;
//   padding-top: 24px;
// }
.hot {
  width: 256px;
  float: left;
  margin-left: 24px;
  border: 1px solid #e0e6ed;
}
.changeCity {
  margin-bottom: 151px;
}
</style>
